export default __webpack_public_path__ + "13e5682ecdb6213877f96a3dfbb9dbba.svg";